import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { GET_BANK, UPDATE_BANK_STATUS, DELETE_BANK, ADD_BANK, COPY_BANK, EDIT_BANK } from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { logout } from "../../utils";
import { GetBankSuccess, GetBankFailure, UpdateBankStatusSuccess, UpdateBankStatusFailure, DeleteBankSuccess, DeleteBankFailure, EditBankSuccess, EditBankFailure, AddBankSuccess, AddBankFailure, CopyBankSuccess, CopyBankFailure } from "../Actions/BankAction";

function* EditBankRequest(actions) {
  console.log("Edit Bank Request");
  function getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  }

  const data = {
    id: actions.payload.id,
    name: actions.payload.name,
    bank_code: actions.payload.bank_code,
    street: actions.payload.street,
    street2: actions.payload.street2,
    city: actions.payload.city,
    state: actions.payload.state,
    postal_code: actions.payload.postal_code,
    phone: actions.payload.phone,
    from_email: actions.payload.from_email,
    from_name: actions.payload.from_name,
    logo: actions.payload.logo,
    backgroundcolor: actions.payload.backgroundcolor,
    cardcolor: actions.payload.cardcolor,
    textcolor: actions.payload.textcolor,
    primarycolor: actions.payload.primarycolor,
    iconcolor: actions.payload.iconcolor,
    web_site_url: actions.payload.web_site_url,
    facebookurl: actions.payload.facebookurl,
    twitterurl: actions.payload.twitterurl,
    instagramurl: actions.payload.instagramurl,
    tiktokurl: actions.payload.tiktokurl,
    linkedinurl: actions.payload.linkedinurl,
    themeid: actions.payload.themeid,
    onfleet_api_key: actions.payload.onfleet_api_key,
  };
  //console.log(actions);

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/edit_bank`, getFormData(data), {
      headers: defaultHeaders(),
    });
    //console.log(res);
    if (res.status === 200) {
      yield put(EditBankSuccess(res.data));
    } else yield put(EditBankFailure(res));
  } catch (e) {
    console.log(e);
    yield put(EditBankFailure(e));
  }
}

function* CopyBankRequest(actions) {
  function getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  }

  const data = {
    name: actions.payload.name,
    bank_code: actions.payload.bank_code,
    copyFrom: actions.payload.copyFrom,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/copy_bank`, getFormData(data), { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(CopyBankSuccess(res.data));
    } else {
      yield put(CopyBankFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(CopyBankFailure(e));
  }
}

function* AddBankRequest(actions) {
  console.log("Add Bank Request");
  function getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  }

  const data = {
    name: actions.payload.name,
    bank_code: actions.payload.bank_code,
    street: actions.payload.street,
    street2: actions.payload.street2,
    city: actions.payload.city,
    state: actions.payload.state,
    postal_code: actions.payload.postal_code,
    phone: actions.payload.phone,
    from_email: actions.payload.from_email,
    from_name: actions.payload.from_name,
    logo: actions.payload.logo,
    backgroundcolor: actions.payload.backgroundcolor,
    cardcolor: actions.payload.cardcolor,
    textcolor: actions.payload.textcolor,
    primarycolor: actions.payload.primarycolor,
    iconcolor: actions.payload.iconcolor,
    web_site_url: actions.payload.web_site_url,
    facebookurl: actions.payload.facebookurl,
    twitterurl: actions.payload.twitterurl,
    instagramurl: actions.payload.instagramurl,
    tiktokurl: actions.payload.tiktokurl,
    linkedinurl: actions.payload.linkedinurl,
    themeTitle: actions.payload.themeTitle,
    header_card_image: actions.payload.header_card_image,
    icon: actions.payload.icon,
    onfleet_api_key: actions.payload.onfleet_api_key,
  };
  //console.log(actions);

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/add_bank`, getFormData(data), {
      headers: defaultHeaders(),
    });
    //console.log(res);
    if (res.status === 200) {
      yield put(AddBankSuccess(res.data));
    } else yield put(AddBankFailure(res));
  } catch (e) {
    console.log(e);
    yield put(AddBankFailure(e));
  }
}

function* GetBankRequest(actions) {
  console.log("called");
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/maintain_bank_list?status=${actions.payload.status}&sort_by=${actions.payload.sort_by}&sort_type=${actions.payload.sort_type}&search_key=${actions.payload.search_key}`, { headers: defaultHeaders() });
    if (res.status === 200) {
      console.log(res);
      yield put(GetBankSuccess(res.data));
    } else {
      yield put(GetBankFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetBankFailure(e));
  }
}

function* UpdateBankStatusRequest(actions) {
  const body = {
    id: actions.payload.id,
    bank_status: actions.payload.bank_status,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_bank_status`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });

    console.log(process.env.REACT_APP_API_URL);
    console.log(res);
    if (res.status === 200) {
      yield put(UpdateBankStatusSuccess(res.data));
    } else {
      yield put(UpdateBankStatusFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateBankStatusFailure(e));
  }
}

function* DeleteBankRequest(actions) {
  try {
    const res = yield axios.delete(`${process.env.REACT_APP_API_URL}api/admin/bank/${actions.payload}`, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(DeleteBankSuccess(res.data));
    } else {
      yield put(DeleteBankFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(DeleteBankFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_BANK, GetBankRequest);
  yield takeLatest(UPDATE_BANK_STATUS, UpdateBankStatusRequest);
  yield takeLatest(DELETE_BANK, DeleteBankRequest);
  yield takeLatest(ADD_BANK, AddBankRequest);
  yield takeLatest(COPY_BANK, CopyBankRequest);
  yield takeLatest(EDIT_BANK, EditBankRequest);
}

export default function* GetBankSaga() {
  yield all([actionWatcher()]);
}
